module.exports = __webpack_public_path__ + "img/hyhz.dee0016c.png";